module.exports = __webpack_public_path__ + "static/media/common_booster.e0e59b89.webp";